import {Component, inject, Inject} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {TournamentPlayer} from "../../model/tournamentPlayer";
import {FormsModule} from "@angular/forms";
import {Event} from "../../model/event";

@Component({
  selector: 'app-substitute-selection',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    FormsModule,
    MatDialogClose,
  ],
  templateUrl: './substitute-selection.component.html',
  styleUrl: './substitute-selection.component.scss',
  standalone: true
})
export class SubstituteSelectionComponent {

  substitute: TournamentPlayer[];

  readonly dialogRef = inject(MatDialogRef<SubstituteSelectionComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    player: TournamentPlayer,
    availablePlayers: TournamentPlayer[]
  }) {}

  onAnnulerenClick() {
    this.dialogRef.close();
  }

  protected readonly Event = Event;
}
